/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeekModelByNameResponse } from './WeekModelByNameResponse';
import {
    WeekModelByNameResponseFromJSON,
    WeekModelByNameResponseFromJSONTyped,
    WeekModelByNameResponseToJSON,
    WeekModelByNameResponseToJSONTyped,
} from './WeekModelByNameResponse';

/**
 * Response for timeslot
 * @export
 * @interface TimeslotResponse
 */
export interface TimeslotResponse {
    /**
     * Unique identifier of the day model
     * @type {string}
     * @memberof TimeslotResponse
     */
    timeslotId?: string;
    /**
     * Start date of timeslot
     * @type {string}
     * @memberof TimeslotResponse
     */
    startDate?: string;
    /**
     * End date of timeslot
     * @type {string}
     * @memberof TimeslotResponse
     */
    endDate?: string;
    /**
     * 
     * @type {WeekModelByNameResponse}
     * @memberof TimeslotResponse
     */
    weekModel?: WeekModelByNameResponse;
    /**
     * True if a special day exist for the same period
     * @type {boolean}
     * @memberof TimeslotResponse
     */
    specialDayExist?: boolean;
}

/**
 * Check if a given object implements the TimeslotResponse interface.
 */
export function instanceOfTimeslotResponse(value: object): value is TimeslotResponse {
    return true;
}

export function TimeslotResponseFromJSON(json: any): TimeslotResponse {
    return TimeslotResponseFromJSONTyped(json, false);
}

export function TimeslotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeslotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'timeslotId': json['timeslotId'] == null ? undefined : json['timeslotId'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'weekModel': json['weekModel'] == null ? undefined : WeekModelByNameResponseFromJSON(json['weekModel']),
        'specialDayExist': json['specialDayExist'] == null ? undefined : json['specialDayExist'],
    };
}

export function TimeslotResponseToJSON(json: any): TimeslotResponse {
    return TimeslotResponseToJSONTyped(json, false);
}

export function TimeslotResponseToJSONTyped(value?: TimeslotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeslotId': value['timeslotId'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'weekModel': WeekModelByNameResponseToJSON(value['weekModel']),
        'specialDayExist': value['specialDayExist'],
    };
}

